<div dynamicGrid [tableContainerElement]="tableContainer" [selector]="selector" fxLayout="column" fxLayoutGap="10px">
  <h2 class="page-header left">
    Mantenimiento de Usuarios
  </h2>
  <div fxLayout="row" fxLayout.lt-md="column" class="right" *ngIf="canCreateUpdateUser">
    <button mat-icon-button color="primary" class="button1" (click)="addRow()">
      <mat-icon>add_circle</mat-icon>
    </button>
    <button mat-icon-button color="primary" class="button1" (click)="saveRows()" [disabled]="disableSaveButton">
      <mat-icon>save</mat-icon>
    </button>
  </div>
  <fab-loading-spinner *ngIf="isLoading"></fab-loading-spinner>
  <div #tableContainer class="table-height">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
      <!-- gmin Column -->
      <ng-container matColumnDef="gmin">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> GMIN
          <rem-string-filter #tableFilter columnDef="gmin" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
          <span *ngIf="!element.add">{{element.gmin}}</span>
          <mat-form-field appearance="fill" *ngIf="element.add" class="cell-width-lgtext">
            <input autocomplete="off" matInput [(ngModel)]="element.gmin" (ngModelChange)="onGminChange(element)" required pattern="[0-9]{9}" minlength="9" maxlength="9">
            <mat-icon matPrefix *ngIf="element.gmin !== element.originalUser.gmin && !element.add"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>
      <!-- First Name Column -->
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Nombre
          <rem-string-filter #tableFilter columnDef="nombre" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-xltext">
          <span *ngIf="!element.loading"> {{element.nombre}} </span>
          <mat-spinner *ngIf="element.loading" class="loading-spinner-small" diameter="20"></mat-spinner>
          <span *ngIf="element.failNames" class="mat-form-field-required-marker">No encontrado</span>
        </td>
      </ng-container>
      <!-- Last Name Column -->
      <ng-container matColumnDef="apellido">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Apellido
          <rem-string-filter #tableFilter columnDef="apellido" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-xltext">
          <span *ngIf="!element.loading"> {{element.apellido}} </span>
          <mat-spinner *ngIf="element.loading" class="loading-spinner-small" diameter="20"></mat-spinner>
          <span *ngIf="element.failNames" class="mat-form-field-required-marker">No encontrado</span>
        </td>
      </ng-container>
      <!-- Role (dropdown) Column -->
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Role
          <rem-string-filter #tableFilter columnDef="roleName" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
          <span *ngIf="!element.editing; else roleDropdown"> {{element.role.role}} </span>
          <ng-template #roleDropdown>
            <mat-form-field appearance="fill" class="cell-width-lgtext">
              <mat-select [(ngModel)]="element.role.id" name="role" (ngModelChange)="onRoleChange(element.role)"
                          required>
                <mat-option *ngFor="let userRole of userRoles" [value]="userRole.id">
                  {{userRole.role}}
                </mat-option>
              </mat-select>
              <mat-icon matPrefix *ngIf="element.role.id !== element.originalUser.role.id && !element.add"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>
      <!-- estado Column -->
      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef scope="col">Estado
          <!--          <rem-string-filter #tableFilter columnDef="estado" (filterChange)="filterChange($event);"></rem-string-filter>-->
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div *ngIf="!element.editing || element.add; else estadoBox">
            <span *ngIf="element.estado">Active</span>
            <span *ngIf="!element.estado">Inactive</span>
          </div>
          <ng-template #estadoBox>
            <mat-form-field appearance="fill" class="cell-width-mtext">
              <mat-select [(ngModel)]="element.estado" name="estado" required>
                <mat-option [value]=true>
                  Active
                </mat-option>
                <mat-option [value]=false>
                  Inactive
                </mat-option>
              </mat-select>
              <mat-icon matPrefix *ngIf="element.estado !== element.originalUser.estado && !element.add"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>
      <!-- usrCreacion Column -->
      <ng-container matColumnDef="usrCreacion">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header>Usu<br>Creación
          <rem-string-filter #tableFilter columnDef="usrCreacion" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          {{element.usrCreacion}}
        </td>
      </ng-container>
      <!-- fecCreacion Column -->
      <ng-container matColumnDef="fecCreacion">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Fec<br>Creación
          <rem-date-filter #tableFilter columnDef="fecCreacion" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></rem-date-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          {{element.fecCreacion | customDate}}
        </td>
      </ng-container>
      <!-- usrModif Column -->
      <ng-container matColumnDef="usrModif">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Usu<br>Modificación
          <rem-string-filter #tableFilter columnDef="usrModif" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          {{element.usrModif ?? ""}}
        </td>
      </ng-container>
      <!-- fecModif Column -->
      <ng-container matColumnDef="fecModif">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Fec<br>Modificación
          <rem-date-filter #tableFilter columnDef="fecModif" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></rem-date-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          {{element.fecModif | customDate}}
        </td>
      </ng-container>
      <!-- Edited Indicator -->
      <ng-container matColumnDef="edited">
        <th mat-header-cell *matHeaderCellDef scope="col"></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button *ngIf="element.editing && canCreateUpdateUser" (click)="revertRow(element)">
            <mat-icon color="tertiary">cancel</mat-icon>
          </button>
          <button mat-icon-button *ngIf="!element.editing && canCreateUpdateUser" (click)="edit(element)">
            <mat-icon color="secondary">create</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [pageSize]="defaultPageSize"
                 [pageSizeOptions]="pageSizeOptions"></mat-paginator>
</div>
